import React, { useEffect } from "react";
import {
  Create,
  CreateProps,
  NumberInput,
  SimpleForm,
  TextInput,
  ImageInput,
  ImageField,
  required,
  SelectField,
  SelectInput,
  BooleanInput,
  ReferenceInput,
  ArrayInput,
  SimpleFormIterator
} from "react-admin";
import { makeStyles } from "@material-ui/core";
import axios from "axios";
import UploadImages from './UploadImages';
import RichTextInput from "ra-input-rich-text";

const useStyles = makeStyles((table) => ({
  description: {
    width: 600,
  },
  content: {
    width: 800,
  },
}));

const categoriesList = [
  { id: "1", name: 'Edible Oil'},
  { id: "2", name: 'Mayonnaise'},
  { id: "3", name: 'Fats'},
  { id: "4", name: 'Horeca'},
  { id: "5", name: 'Sauces'},
  { id: "6", name: 'Bouillon'},
];

const ProductCreate = (props: CreateProps) => {
  const classes = useStyles();
  return (
    <Create {...props}>
      <SimpleForm>
        <TextInput source="name_en" validate={required()} label="Name (English)"/>
          <TextInput source="name_ar" validate={required()} label="Name (Arabic)"/>

          <TextInput source="barcode" validate={required()} label="Barcode"/>

          <UploadImages sourceName="featured_image" multiple={false} />
          <UploadImages sourceName="images" multiple={true} />

          <RichTextInput source="short_desc_en" label="Short Description (English)"/>
          <RichTextInput source="short_desc_ar" label="Short Description (Arabic)" />

          <RichTextInput source="long_desc_en" label="Long Description (English)" />
          <RichTextInput source="long_desc_ar" label="Long Description (English)" />

          <ReferenceInput source="category_id" reference="categories" label="Category">
                <SelectInput optionText="name_en" />
          </ReferenceInput>
          <ArrayInput source="nutrition" label="Nutrition">
                <SimpleFormIterator>
                    <TextInput source="label_en" helperText={false} label="Text (English)" />
                    <NumberInput source="value_en" helperText={false} label="Value (English)" />
                    <TextInput source="label_ar" helperText={false} label="Text (Arabic)" />
                    <NumberInput source="value_ar" helperText={false} label="Value (Arabic)" />
                    <TextInput source="style" helperText={false} label="Class" />
                </SimpleFormIterator>
            </ArrayInput>
          <TextInput source="price" label="Price" />
          <BooleanInput source="active" label="Active" />  
      </SimpleForm>
    </Create>
  );
};

export default ProductCreate;
